import Cookie from "js-cookie";
import { I18n } from "aws-amplify";
import React from "react";

export const createExcerpt = (description, isMobile = null) => {
  const excerptLength = isMobile ? 80 : 150;

  if (description === null) return <p>Clique e saiba mais.</p>;

  if (description.length > excerptLength)
    return <p>{description.substring(0, excerptLength)}...</p>;

  if (description.length <= excerptLength) return <p>{description}</p>;
};

export const verifyPromoDates = (startDate, endDate) => {
  if (!startDate || !endDate) return false;

  const today = new Date();
  const promoStart = new Date(startDate);
  const promoClosed = new Date(endDate);

  if (promoStart < today && promoClosed > today) return true;

  return false;
};

export const verifyPromoLastHours = (endDate) => {
  if (!endDate) return false;

  const now = new Date();
  const promoEnd = new Date(endDate);
  const twoDays = 1000 * 60 * 60 * 24 * 2;

  if (now > promoEnd) return false;

  const difference = Math.abs(promoEnd - now) / twoDays;

  if (difference <= 1) return true;

  return false;
};

export const millisToMinutesAndSeconds = (millis) => {
  if (!millis) return "0";

  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(0);
  return seconds === 60
    ? minutes + 1 + ":00"
    : minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
};

export const normalizeString = (string = "") => {
  if (!string || typeof string !== "string") return string;

  return string
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replaceAll(" ", "_");
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// unused methods
export const createAuthCookie = (jwtToken) => {
  if (!jwtToken) {
    redirectToLogin();
  }

  if (window.location.origin.indexOf("localhost")) {
    Cookie.set(process.env.REACT_APP_TOKEN, jwtToken, {
      expires: 1826,
    });
  }

  Cookie.set(process.env.REACT_APP_TOKEN, jwtToken, {
    expires: 1826,
    domain: process.env.REACT_APP_DOMAIN,
  });
};
export const clearCookie = () => {
  localStorage.clear();
  if (window.location.origin.indexOf("localhost")) {
    Cookie.remove(process.env.REACT_APP_TOKEN);
  }
  Cookie.remove(process.env.REACT_APP_TOKEN, {
    domain: process.env.REACT_APP_DOMAIN,
  });
};
export const Error = (e) => {
  const DURACAO_MSG_MILISSEGUNDOS = 7500;
  let strArr = e.message.split(":");

  strArr = strArr
    .filter((str) => str !== "1 validation error detected")
    .map((str) => {
      return I18n.get(str.trim());
    });

  let flashDiv = document.createElement("div");
  flashDiv.id = "flashDiv";

  flashDiv.innerHTML = strArr.join(": ");
  document.getElementsByTagName("body")[0].appendChild(flashDiv);

  setTimeout(() => {
    flashDiv = document.getElementById("flashDiv");
    if (flashDiv) {
      // se existe
      document.getElementsByTagName("body")[0].removeChild(flashDiv);
    }
  }, DURACAO_MSG_MILISSEGUNDOS);
};
export const hasAdmin = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("adm") === "true";
};
export const redirectTo = (redirect = "") => {
  if (redirect) {
    window.location.href = `${redirect}${window.location.search}`;
  } else if (hasAdmin()) {
    window.location.href = `http://admin.${process.env.REACT_APP_DOMAIN}/admin/?entity=Subscription`;
  } else {
    window.location.href = `http://${process.env.REACT_APP_DOMAIN}`;
  }
};
export const redirectToLogin = (msg = null) => {
  const url = new URL("/signin", window.location.href);

  if (msg) {
    url.searchParams.set("msg", msg);
  }

  if (hasAdmin()) {
    url.searchParams.set("adm", "true");
  }

  window.location.href = url;
};
export const createCookieUtms = (utmKey, utmValue) => {
  Cookie.remove(utmKey);

  if (window.location.origin.indexOf("localhost")) {
    Cookie.set(utmKey, utmValue, {
      expires: 7,
    });
  }

  Cookie.set(utmKey, utmValue, {
    expires: 7,
    domain: process.env.REACT_APP_DOMAIN,
  });
};
// end of unused methods
